
<div class="admin">
	<header>
		<div class="logo"></div>
	</header>
	<router-outlet></router-outlet>
</div>

<!-- Shared by every confirmation in the admin. Without a width it grows to fit the message on one line. -->
<!-- Button colours follow the dialog rule in main.scss: Cancel neutral, action success (a prompt passes acceptButtonStyleClass: 'danger' for destructive actions). -->
<p-confirmDialog [style]="{ width: '480px', maxWidth: '90vw' }" acceptButtonStyleClass="success" rejectButtonStyleClass="neutral" />